export function getAuthorizationHeaderKey(headers = {}) {
	for (const key of Object.keys(headers || {})) {
		if (String(key).toLowerCase() === "authorization") {
			return key;
		}
	}

	return "";
}

export function setAuthorizationHeader(headers = {}, token, key) {
	if (!token) {
		return headers || {};
	}

	const nextHeaders = {
		...(headers || {})
	};
	const headerKey = key || getAuthorizationHeaderKey(nextHeaders) || "Authorization";

	nextHeaders[headerKey] = token;
	return nextHeaders;
}

export function ensureAuthorizationHeader(headers = {}, token) {
	if (!token) {
		return headers || {};
	}

	const existingKey = getAuthorizationHeaderKey(headers);
	if (existingKey) {
		return headers || {};
	}

	return setAuthorizationHeader(headers, token);
}
